import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearTaskDetails,
  getSubTaskDetails,
  getTaskDetails,
} from "../../API/store/actions/tasks";
import TaskComments from "./taskComments";
import TaskDetails from "./taskDetails";
import { useParams } from "react-router-dom";
import Loading from "../reusableComponents/loadingScreens";
import { ScrollToTop } from "../../algorithms";
import { resolver } from "../../API/middlewares/resolveRequests";
import SubTaskDetails from "./subTaskDetails";
import SubTaskComments from "./subTaskComments";

const SubTaskDetailsIndex = ({ userToken }) => {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const [displayComments, setDisplayComments] = useState({
    display: false,
    id: null,
    content: [],
    owner: {},
  });

  const [procAdded, setProcAdded] = useState(false);
  const [subDetails, setSubDetails] = useState(false);

  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    resolver(getSubTaskDetails, setSubDetails, parseInt(id), userToken);
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener("resize", handleResize);
    ScrollToTop();
    return () => {
      dispatch(clearTaskDetails());
      window.removeEventListener("resize", handleResize);
    };
  }, [windowDimensions, procAdded]);

  if (subDetails?.data)
    return (
      <>
        <div className="d-flex flex-column align-items-center align-items-sm-start col-xl-8 col">
          <SubTaskDetails
            details={subDetails?.data}
            commentsUnderProcedure={
              windowDimensions.width <= 1200 ? true : false
            }
            displayComments={displayComments}
            setDisplayComments={setDisplayComments}
            setProcAdded={setProcAdded}
            procAdded={procAdded}
          />
        </div>

        {windowDimensions.width > 1200 && displayComments.display ? (
          <>
            <SubTaskComments
              TasksDetails={subDetails}
              displayComments={displayComments}
              setDisplayComments={setDisplayComments}
            />
          </>
        ) : null}
      </>
    );
  else
    return (
      <div>
        <Loading />
      </div>
    );
};

export default SubTaskDetailsIndex;

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
